import { useMutation, useQuery } from "@tanstack/react-query";
import { ThirdPartyApi } from "../api/third-party-api";
import { ThirdPartyVideoDto } from "@repo/api/third-party-video";

export function useThirdPartyConfigQuery(
  token: string | null,
  userId: string | null,
) {
  return useQuery({
    queryKey: thirdPartyQueryKeys.getThirdPartyConfig(token!, userId),
    queryFn: () => ThirdPartyApi.getThirdPartyConfig(token!),
    staleTime: Infinity,
    meta: {
      errorMessage: "Failed to fetch integration details",
    },
    enabled: !!token,
  });
}

export function useUpsertThirdPartyVideoMutation({
  teamExternalId,
  token,
  onSuccess,
  onError,
}: {
  teamExternalId: string;
  token: string;
  onSuccess?: (data: ThirdPartyVideoDto) => void;
  onError?: (error: Error) => void;
}) {
  return useMutation({
    mutationFn: () =>
      ThirdPartyApi.upsertThirdPartyVideo(teamExternalId, token),
    onSuccess,
    onError,
  });
}

export const thirdPartyQueryKeys = {
  all: () => ["third-party"],
  getThirdPartyConfig: (token: string, userId: string | null) => [
    "third-party",
    "config",
    { token, userId },
  ],
};
